export const CUSTOM_COLUMN = 'customColumn';
export const CUSTOM_COLUMN_ATTRIBUTE = 'customColumnAttribute';
